export default class KapcsolatPopupController {
	constructor(kapcsolatService, $scope) {
		'ngInject';
		this.zipCodeError = false;
		this._kapcsolatService = kapcsolatService;
		this._$scope = $scope;
		this.model = {};
		this._$scope.$watch('$ctrl.kivalasztottSzolgaltatasok', () => {
			this.model.szolgaltatas = [];
			angular.forEach(this.kivalasztottSzolgaltatasok, (value, key) => {
				if (value) {
					this.model.szolgaltatas.push(key);
				}
			});
		}, true);
		this._getSzolgaltatasok();
		this.captchaUrl = this._getCaptchaUrl();
	}
	_getSzolgaltatasok() {
		this._kapcsolatService.getSzolgaltatasok().then((response) => {
			this.szolgaltatasok = response;
		}, () => {
			this.technikaiHiba = true;
		});
	}
	getVarosokByIrszam() {
		this._kapcsolatService.getVarosokByIrszam(this.model.iranyitoszam).then((response) => {
			this.zipCodeError = false;
			this.varosok = response;
			if (!this.varosok.length) {
				this.zipCodeError = true;
			}
			if (this.varosok.length == 1) {
				this.model.varos = this.varosok[0];
			} else {
				this.model.varos = '';
			}
		}, () => {
			this.technikaiHiba = true;
		});
	}
	kuldes(e) {
		e.preventDefault();
		this._kapcsolatService.kuldes(this.model, this.captcha).then(() => {
			this._captchaFrissites();
			this.captcha = '';
			this.success = true;
		}, (err) => {
			if (err.status && err.status == 400 && err.data && err.data.errors) {
				this.errors = err.data.errors;
			} else {
				this.technikaiHiba = true;
			}
			this._captchaFrissites();
			this.captcha = '';
		});

	}
	_captchaFrissites() {
		this.captchaUrl = this._getCaptchaUrl();
	}
	_getCaptchaUrl() {
		return this._kapcsolatService.getCaptchaUrl();
	}
}



// WEBPACK FOOTER //
// ./source/applications/kapcsolat/kapcsolat-popup-controller.js